// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Button_buttonsContainer__24Wfz","button":"Button_button__31KdT"};